import React from 'react';
import { stateAndTerritoryCodes, countryCodes } from './constants';

// CREATE OPTIONS
export const createOptions = (arr = []) => arr.map((d, i) => <option key={i} value={d} className='text-capitalize'>{d}</option>);



// Check if string contains consecutive
export const checkConsecutive = (chars) => {
  for (let i = 0; i < chars.length - 1; i++) {
    if (chars[i] === chars[i + 1]) return true;
  }
  return false;
};



// PASSWORD VALIDATION
export const passwordValidation = (password, options, length) => {
  const isValid = [];

  const _alpha = /[A-Za-z]/.test(password);
  const _numeric = /[0-9]/.test(password);
  const _caps = /[A-Z]/.test(password);
  // eslint-disable-next-line no-useless-escape
  const _symbols = /[!@#$&()\-`.+,/\"]/.test(password);
  const _consecutive = !checkConsecutive(password);
  const _length = password.length;

  if (options.alpha) isValid.push(_alpha);
  if (options.numeric) isValid.push(_numeric);
  if (options.caps) isValid.push(_caps);
  if (options.symbols) isValid.push(_symbols);
  if (options.consecutive) isValid.push(_consecutive);
  if (length) isValid.push(_length >= length);

  for (let i = 0; i < isValid.length; i++) {
    if (!isValid[i]) return false;
  }

  return true;
};



// CONVERT HEXCODES - '#FFFFFF' to (255, 255, 255,)
export const hexToRGB = (hex) => {
  const bigint = parseInt(hex.slice(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `${r}, ${g}, ${b}`;
};



// Render a full address string via provided address object with separate properties
export const renderFullAddress = (addressObj) => {
  let fullAddress = '';
  if (addressObj.address_1) fullAddress += `${addressObj.address_1}`;
  if (addressObj.address_2) fullAddress += `${addressObj.address_1 && ', '}${addressObj.address_2}`;
  if (addressObj.city) fullAddress += `${addressObj.address_1 || addressObj.address_2 ? ', ' : ' '}${addressObj.city}`;
  if (addressObj.state) {
    const foundState = stateAndTerritoryCodes.find((code) => code.value === addressObj.state);
    if (foundState) fullAddress += `${addressObj.city ? ', ' : ' '}${foundState.label}`;
  }
  if (addressObj.zip) fullAddress += ` ${addressObj.zip}`;
  return fullAddress;
};
